import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import apiService from '../../services/apiService';

const AddOffer = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    specialName: '',
    title: '',
    validUntil: '',
    sortDescription: '',
    image: null
  });
  const [imagePreview, setImagePreview] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const maxSize = 1 * 1024 * 1024; // 1MB
      if (file.size > maxSize) {
        toast.error('File size must be 1MB or less.');
        e.target.value = '';
        return;
      }

      setFormData(prev => ({
        ...prev,
        image: file
      }));

      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const submitData = new FormData();
      submitData.append('specialName', formData.specialName);
      submitData.append('title', formData.title);
      submitData.append('validUntil', formData.validUntil);
      submitData.append('sortDescription', formData.sortDescription);
      
      if (formData.image) {
        submitData.append('image', formData.image);
      }

      const response = await apiService.postFormData('updateOffer', submitData);
      
      if (response.success) {
        toast.error(response.message);
      } else {
        toast.success('Offer added successfully');
        navigate('/view-offers');
      }
    } catch (error) {
      console.error('Error adding offer:', error);
      toast.error('Something went wrong, try again!!');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex-1 p-0">
      <div className="mb-3">
          <nav className="flex text-sm text-gray-600">
            <span className="cursor-pointer hover:text-[#009ef7]" onClick={() => navigate('/dashboard')}>Home</span>
            <span className="mx-2">/</span>
            <span className="cursor-pointer hover:text-[#009ef7]" onClick={() => navigate('/offers')}>Offers</span>
            <span className="mx-2">/</span>
            <span className="text-gray-900">Add Offer</span>
          </nav>
      </div>

      <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow p-6">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-5">
            <div className="relative inline-block">
              <div
                className="w-72 h-60 border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center overflow-hidden"
                style={{
                  backgroundImage: imagePreview ? `url(${imagePreview})` : 'none',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }}
              >
                {!imagePreview && <i className="bi bi-image text-4xl text-gray-400"></i>}
              </div>
              <label
                className="absolute bottom-2 right-2 w-6 h-6 bg-white rounded-full shadow flex items-center justify-center cursor-pointer hover:bg-gray-50"
                title="Change image"
              >
                <i className="bi bi-pencil text-xs"></i>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  className="hidden"
                />
              </label>
            </div>
            <p className="text-sm text-gray-500 mt-2">Max file size: 1MB</p>
          </div>

          <div className="col-span-7 space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Special Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="specialName"
                value={formData.specialName}
                onChange={handleChange}
                placeholder="Enter special name"
                className="w-full px-2 sm:px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#009ef7] focus:border-transparent"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Title <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                placeholder="Enter title"
                className="w-full px-2 sm:px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#009ef7] focus:border-transparent"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Valid Until</label>
              <input
                type="date"
                name="validUntil"
                value={formData.validUntil}
                onChange={handleChange}
                className="w-full px-2 sm:px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#009ef7] focus:border-transparent"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Short Description</label>
              <textarea
                name="sortDescription"
                value={formData.sortDescription}
                onChange={handleChange}
                placeholder="Enter short description"
                rows="3"
                className="w-full px-2 sm:px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#009ef7] focus:border-transparent"
              />
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-end gap-3 mt-6">
          <button
            type="button"
            onClick={() => navigate('/view-offers')}
            className="px-6 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={loading}
            className="px-6 py-2 text-sm font-medium text-white rounded-lg"
            style={{ backgroundColor: '#009ef7' }}
          >
            {loading ? 'Please wait...' : 'Save'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddOffer;
